import { call, put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import { UPLOAD_MEDIA_FILE } from './constants';
import { uploadMediaFileSuccess, uploadMediaFileError } from './actions';
import _local from 'utils/localStorageUtils';

export function* uploadMediaFileSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { file, fileType } = action;

    let result = false;

    if (fileType !== 'video' && file) {
      result = yield requestWrapper(
        'POST-FORM-DATA',
        'media/upload/',
        file,
        currentUser.token,
      );
    } else if ( file ) {
      result = yield requestWrapper(
        'POST-FORM-DATA',
        'media/upload-video/',
        file,
        currentUser.token,
      );
    }

    if (result) {
      yield put(uploadMediaFileSuccess(result, fileType));
    }
  } catch (err) {
    yield put(uploadMediaFileError(err));
  }
}

// Individual exports for testing
export default function* uploadMediaSaga() {
  yield takeLatest(UPLOAD_MEDIA_FILE, uploadMediaFileSaga);
}
